import { useTranslation } from 'react-i18next';
import { generateComparativeValue } from '../../../../../../util';
import { Box, Skeleton, Typography } from '../../../../../1-primative';
import { Card, CardContent } from '../../../../../2-component';
import { useThemeTokens } from '../../../../../../providers/themeTokenProvider';

export const NumberWidget = ({
  title,
  newValue,
  oldValue,
  loading,
  isCurrency = true,
  isPercentage = false,
}: {
  title: string;
  newValue: number;
  oldValue: number;
  loading: boolean;
  isCurrency?: boolean;
  isPercentage?: boolean;
}) => {
  const { t } = useTranslation('homePageConfiguration');
  const { value, isIncrease, changeText } = generateComparativeValue(
    newValue,
    oldValue,
    isCurrency,
    isPercentage,
    t('practiceOverview.fromLastMonth'),
  ) ?? { value: '', isIncrease: false, changeText: '' };
  const { sys } = useThemeTokens();
  return (
    <Card sx={{ flex: 1, height: '170px' }}>
      <CardContent sx={{
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'calc(100% - 32px)',
      }}>
        <Typography variant='bodyLarge' colorVariant='variant'>{title}</Typography>
        <Box display='flex' flexDirection='column'>
          { loading ? (
            <Skeleton variant='text' width='70%' height='24px' />
          ) : (
            <Typography variant='displayMedium' sx={{ fontVariantNumeric: 'tabular-nums' }}>{value}</Typography>
          )}
          {changeText && (
            <Typography variant='bodySmall' sx={{ color: isIncrease ? sys.color.positive : sys.color.negative }}>{changeText}</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
